module.exports = "/images/mexcar.svg?8bca6a917edb65d21b8dd6f9b5339846";